'use strict';

import settings from '../settings';
import store from '../store';
import { AppStoreTypes } from '../store/modules/app';
import { HttpContext } from '../utils/httpContext';

class ProjektService {
  async GetLinkek() {
    const url = settings.baseUrl + 'Api/Projekt/GetLinkek';
    const result = await HttpContext.post({ url });
    store.dispatch(AppStoreTypes.linkek.set, {
      value: result,
    });
    return result;
  }
}

let instance = new ProjektService();
export { instance as projektService };
